namespace $ {

	$mol_style_define( $shm_projects_codex_prompt, {
		overflow: 'hidden',
		Edit: {
			overflow: 'auto',
		},
		View: {
			width: '100%',
			flex: { shrink: 0 },
		},
	} )

}
